import { graphql, type Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';

import {
    type setUserHasConfirmedOrdersCookieMutation,
    type setUserHasConfirmedOrdersCookieMutation$data,
    type SetUserHasConfirmedOrdersCookieInput,
} from './__generated__/setUserHasConfirmedOrdersCookieMutation.graphql.ts';

const mutation = graphql`
    mutation setUserHasConfirmedOrdersCookieMutation(
        $input: SetUserHasConfirmedOrdersCookieInput!
    ) {
        setUserHasConfirmedOrdersCookie(input: $input) {
            clientMutationId
        }
    }
`;

export function setUserHasConfirmedOrdersCookieMutation(
    environment: Environment,
    input: SetUserHasConfirmedOrdersCookieInput
): Promise<setUserHasConfirmedOrdersCookieMutation$data> {
    return commitMutation<setUserHasConfirmedOrdersCookieMutation>(environment, {
        mutation,
        variables: { input },
    });
}
